/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ListItem from '../../../components/Dashboard/ListItem';
import { useLocation } from 'react-router-dom';

const Dashboard = ({
  isDashboardOpen,
  setIsDashboardOpen,
  userId,
  getSavedConfigsForUser,
  savedUserConfigs,
  removeUserConfig,
  loadFromSavedUserConfig
}) => {
  const location = useLocation();
  useEffect(() => {
    // getSavedConfigsForUser(userId, location.pathname.split('/')[1]);
  }, []);
  return (
    <div
      className="dashboard"
      style={{
        opacity: isDashboardOpen ? 1 : 0,
        pointerEvents: isDashboardOpen ? 'all' : 'none'
      }}
    >
      <div
        className="dashboard_close-btn"
        onClick={() => {
          setIsDashboardOpen(false);
        }}
      >
        <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 1.178L18.822 0 10 8.822 1.178 0 0 1.178 8.822 10 0 18.822 1.178 20 10 11.178 18.822 20 20 18.822 11.178 10 20 1.178z" />
        </svg>
      </div>
      {savedUserConfigs && (
        <div
          className={`dashboard_container ${savedUserConfigs.length === 0 &&
            'dashboard_container-flex'}`}
        >
          {savedUserConfigs.length === 0 && (
            <h1>Save a configuration to see your collections !</h1>
          )}
          {savedUserConfigs.map((item, index) => (
            <ListItem
              key={item.userId}
              item={item.orderJson}
              index={index}
              onEditClick={() => {
                loadFromSavedUserConfig(item);
                setIsDashboardOpen(false);
                // history.push("/helmet")
              }}
              onDeleteClick={() => {
                // eslint-disable-next-line no-underscore-dangle
                removeUserConfig(userId, item._id);
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

Dashboard.propTypes = {
  isDashboardOpen: PropTypes.bool,
  setIsDashboardOpen: PropTypes.func,
  userId: PropTypes.string,
  getSavedConfigsForUser: PropTypes.func,
  savedUserConfigs: PropTypes.array,
  removeUserConfig: PropTypes.func,
  loadFromSavedUserConfig: PropTypes.func
};

export default Dashboard;
